module.exports = {
  ASSETS: 'assets',
  MARKETING: 'marketing',
  INVENTORY: 'inventory',
  STAFF: 'staff',
  SERVICES: 'services'
}
